import styled from 'styled-components';

export const StyledJuicerFeed = styled.div``;
